export default __webpack_public_path__ + "static/Sash-5-6676158f14780b45864cc8eb0cf66b64.png";